import localStorageUtil from '@/common/localStorageUtil';
export default {
  isToAcknowledge(item) {
    return item && item.quittierung > 0 && item._userState && !item._userState.dateconfirmed; // 1 with dialog, 2 without dialog
  },
  isToAcknowledgeAndAcknowledged(item) {
    return item && item.quittierung > 0 && item._userState && !!item._userState.dateconfirmed;
  },
  isToAcknowledgeAndNotRead(item) {
    return item && item.quittierung > 0 && item._userState && !item._userState.dateconfirmed; // 1 with dialog, 2 without dialog
  },
  markAsAcknowledged(item) {
    let dateIsoString = new Date().toISOString();
    item._userState.dateconfirmed = dateIsoString;
    item._userState.userdatemodified = dateIsoString;
    item._userState.dateread = dateIsoString;
    console.log('marked item', item, 'as acknoweldged userState', item._userState);

    localStorageUtil.addUserState(item);
  },
};
